import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MuiAlert from '@material-ui/lab/Alert';
import React, { createContext, useContext, useState } from 'react';

export const SnackBarContext = createContext({});

export const useSnackBar = () => {
  return useContext(SnackBarContext);
};

export const SnackBarProvider = ({ children }) => {
  const [state, setState] = useState({
    isOpen: false,
    type: 'info',
    message: '',
  });

  const openSnackBar = (type, message) => {
    setState({
      isOpen: true,
      type: type,
      message: message,
    });
  };

  const closeSnackBar = () => {
    const oldState = state;
    setState({
      isOpen: false,
      type: oldState.type,
      message: oldState.message,
    });
  };

  const contextValue = { state, openSnackBar, closeSnackBar };

  return (
    <SnackBarContext.Provider value={contextValue}>
      {children}
    </SnackBarContext.Provider>
  );
};

const SnackBarProviderConsumer = SnackBarContext.Consumer;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  snackbarOuter: {
    width: '100%',
    alignItems: 'center',
    margin: 'auto',
  },
  snackbar: {
    [theme.breakpoints.up('md')]: { width: '65%' },
    // width: '100%',
    maxWidth: '600px',
    alignItems: 'center',
    margin: 'auto',

    '& .MuiAlert-message': {
      width: '100%',
    },
  },
}));

export const SnackbarAlert = () => {
  const classes = useStyles();

  return (
    <SnackBarProviderConsumer>
      {({ state, closeSnackBar }) => (
        <Snackbar
          open={state.isOpen}
          autoHideDuration={56000}
          onClose={(_, reason) => {
            if (reason === 'clickaway') {
              return;
            } else {
              closeSnackBar();
            }
          }}
          className={classes.snackbar}
        >
          <Alert
            onClose={closeSnackBar}
            severity={state.type}
            className={classes.snackbar}
          >
            <Typography align="center">{state.message}</Typography>
          </Alert>
        </Snackbar>
      )}
    </SnackBarProviderConsumer>
  );
};
